module.exports = __webpack_public_path__ + "static/f2c-impact-43b4313f04beb067d9218724ac3449e3.png";